import { Component, ViewChild } from "@angular/core";
import { DxChartComponent, DxDataGridComponent } from "devextreme-angular";
import { exportDataGrid } from "devextreme/excel_exporter";
import { Workbook } from "exceljs";
import saveAs from 'file-saver';
import { NotificationService } from "src/app/common/component/notification/notification.service";
import { GlobalHycoAwardsSogCompetitorService } from "./h2-global-hyco-awards-sog-competitor.service";
import { DxiSeriesComponent } from "devextreme-angular/ui/nested";
import { exportWidgets } from "devextreme/viz/export";
import query from "devextreme/data/query";

@Component({
    selector: 'GlobalHycoAwards',
    templateUrl: './h2-global-hyco-awards-sog-competitor.component.html',
    styleUrls: ['./h2-global-hyco-awards-sog-competitor.component.scss']
})

export class H2GlobalHycoAwardsSogCompetitorComponent {

    isLoadPanelVisible: boolean = false;
    globalHycoAwardsReportData: any;
    hycoAnalysisData: any;
    sogMarketByPrimaryCompetitorData: any;
    readonly allowedPageSizes = [50, 100, 200];
    colors: Map<string, string> = new Map<string, string>();
    resolveOverlappingTypes = ['shift', 'hide', 'none'];
    @ViewChild(DxDataGridComponent, { static: false }) dataGrid: DxDataGridComponent;
    @ViewChild(DxChartComponent, { static: false }) dxChart: DxChartComponent;
    @ViewChild(DxiSeriesComponent, { static: false }) dxPieChart: DxChartComponent;

    constructor(private notificationService: NotificationService, private globalHycoAwardsService: GlobalHycoAwardsSogCompetitorService) {
        this.colors = new Map<string, string>();
        this.getGlobalHycoAwardsReport();
    }

    getGlobalHycoAwardsReport() {
        this.isLoadPanelVisible = true;
        this.colors.clear();
        this.globalHycoAwardsService.getGlobalHycoAwardsReport().subscribe({
            next: globalASUForecastReportData => {
                this.globalHycoAwardsReportData = globalASUForecastReportData;

                this.hycoAnalysisData = this.getHycoAnalysisChartDataSource(globalASUForecastReportData);
                this.sogMarketByPrimaryCompetitorData = this.getPieChartDataSource(globalASUForecastReportData);


                this.isLoadPanelVisible = false;
            }, error: (error: any) => {
                this.isLoadPanelVisible = false;
                this.notificationService.alert("error", "Error while fetching GlobalASUForecastReport data", error);
            }
        });
    }

    getPieChartDataSource(globalASUForecastReportData) {
        var sogMarketByPrimaryCompResponse = [];
        globalASUForecastReportData.reduce(function (res, value) {
            if (!res[value.hyCOSOGCompetitor]) {
                res[value.hyCOSOGCompetitor] = { hyCOSOGCompetitor: value.hyCOSOGCompetitor, totalHyCOMMSCFD: 0 };
                sogMarketByPrimaryCompResponse.push(res[value.hyCOSOGCompetitor])
            }
            res[value.hyCOSOGCompetitor].totalHyCOMMSCFD += value.totalHycoMMSCFD;
            return res;
        }, {});

        for (let index = 0; index < sogMarketByPrimaryCompResponse.length; ++index) {
            var item = sogMarketByPrimaryCompResponse[index];
            item.totalHyCOMMSCFD = item.totalHyCOMMSCFD.toFixed(1);
        }

        return sogMarketByPrimaryCompResponse;
    }
    getHycoAnalysisChartDataSource(globalASUForecastReportData) {
        var calculatedResponse = [];
        for (let index = 0; index < globalASUForecastReportData.length; ++index) {
            const reportItem = globalASUForecastReportData[index];
            if (calculatedResponse.some(e => e.hycoCategory === reportItem.hycoCategory && e.hyCOSOGCompetitor === reportItem.hyCOSOGCompetitor)) {
                /* vendors contains the element we're looking for */
                var existingItem = calculatedResponse.find(f => f.hycoCategory === reportItem.hycoCategory && f.hyCOSOGCompetitor === reportItem.hyCOSOGCompetitor)
                if (existingItem != null) {
                    existingItem.totalHycoMMSCFD += reportItem.totalHycoMMSCFD;
                }
            }
            else {
                calculatedResponse.push({ hycoCategory: reportItem.hycoCategory, hyCOSOGCompetitor: reportItem.hyCOSOGCompetitor, totalHycoMMSCFD: reportItem.totalHycoMMSCFD });
            }
        }

        return calculatedResponse;
    }

    resetFilters() {
        this.dataGrid.instance.clearFilter();
        this.dataGrid.instance.clearSorting();
    }

    customizeTooltip(arg: any) {
        return {
            text: `${arg.seriesName} : ${arg.valueText}`,
        };
    }

    customizeLabelPieChart1(arg) {
        if (this.colors && !this.colors.has(arg.argumentText)) {
            this.colors.set(arg.argumentText, arg.point.getColor());
        }
        return `${arg.argumentText} (${arg.value}) - ${arg.percentText}`;
    }

    customizeLabelPieChart2(arg) {
        if (this.colors && !this.colors.has(arg.argumentText)) {
            this.colors.set(arg.argumentText, arg.point.getColor());
        }
        return `${arg.argumentText} (${arg.percentText})`;
    }

    customizePoint = (arg: any) => {
        if (this.colors.has(arg.data.hyCOSOGCompetitor)) {
            return { color: this.colors.get(arg.data.hyCOSOGCompetitor), hoverStyle: { color: this.colors.get(arg.data.hyCOSOGCompetitor) } };
        }
    }

    exportExcel(e) {
        this.dataGrid.instance.columnOption('siteId', 'visible', true);
        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet('Main sheet');
        exportDataGrid({
            component: this.dataGrid.instance,
            worksheet: worksheet
        }).then(function () {
            workbook.xlsx.writeBuffer()
                .then(function (buffer: BlobPart) {
                    saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'GlobalHYCOAwardsSogCompetitorReportData.xlsx');
                });
        }).then(() => {
            this.dataGrid.instance.columnOption('siteId', 'visible', false);
        });
        e.cancel = true;
    }

    exportCharts() {
        const chartInstance = this.dxChart.instance;
        const pieChartInstance = this.dxPieChart.instance;

        exportWidgets([[chartInstance, pieChartInstance]], {
            fileName: 'GlobalHycoAwardsByPrimarySOG',
            format: 'PNG',
        });
    }

    onGlobalHycoAwardsReportGridOptionChanged(e) {
        if (e.fullName.indexOf("filterValue") > -1) {
            setTimeout(() => {
                var filterExpr = e.component.getCombinedFilter(true);

                if (filterExpr) {
                    let filteredData = query(this.globalHycoAwardsReportData)
                        .filter(filterExpr)
                        .toArray();
                    this.hycoAnalysisData = this.getHycoAnalysisChartDataSource(filteredData);
                    this.sogMarketByPrimaryCompetitorData = this.getPieChartDataSource(filteredData);
                } else {
                    this.hycoAnalysisData = this.getHycoAnalysisChartDataSource(this.globalHycoAwardsReportData);
                    this.sogMarketByPrimaryCompetitorData = this.getPieChartDataSource(this.globalHycoAwardsReportData);
                }
            });
        }
    }
}